/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import apiClient from '../api/client';

export const accountService = {
  getAccounts: (params) => apiClient.get('/accounts', { params }),
  getAccountById: (id) => apiClient.get(`/accounts/${id}`),
  createAccount: (data) => apiClient.post('/accounts', data),
  updateAccount: (id, data) => apiClient.patch(`/accounts/${id}`, data),
  deleteAccount: (id) => apiClient.delete(`/accounts/${id}`)
};
